// Sitewide structured data for CarLens. Organization + WebSite + AggregateRating.
// AggregateRating/reviews mirror the testimonials shown on the homepage (Google-compliant:
// the reviewed content is visible on-page).

const SITE_URL = 'https://carlensauto.com';
const LOGO =
  'https://customer-assets.emergentagent.com/job_5a750074-0ac9-4c5b-a0c0-950bd565c9c5/artifacts/advll02n_ChatGPT%20Image%20Jul%2011%2C%202026%2C%2004_01_30%20PM.png';

const REVIEWS = [
  { author: 'dexter04', rating: 5, body: '10 out of 10, will recommend. CarLens Auto Inspections took the fear out of buying a used vehicle \u2014 very professional, very thorough, and made the whole process very easy. From now on, anytime I go to buy a car I\u2019ll definitely be using them.' },
  { author: 'Mehdi B.', rating: 5, body: 'Amazing service that I cannot ever imagine buying another used car without. Saved me thousands of dollars and a potential headache.' },
  { author: 'Evelina G.', rating: 5, body: 'He did an inspection on a used car I was interested in buying. He was very helpful and explained everything in detail, and was honest too! Would totally recommend him! Great customer service!' },
  { author: 'Steve R.', rating: 5, body: 'My technician was very professional and provided the most detailed report I\u2019ve ever seen on the condition of the truck I was interested in buying. Answered all of my questions.' },
  { author: 'JT D.', rating: 5, body: 'One of my players was looking to purchase a car and Daniel was amazing in all of his help. I would absolutely recommend them!' },
  { author: 'Trace D.', rating: 5, body: 'Had them do an inspection on a vehicle I already own and they were very insightful and helpful \u2014 pointed out things I wouldn\u2019t have caught on my own.' },
];

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'AutomotiveBusiness',
  '@id': `${SITE_URL}/#organization`,
  name: 'CarLens Inspections',
  alternateName: 'CarLens Automotive Intelligence',
  description:
    'Independent mobile pre-purchase vehicle inspections serving Northeast Florida. Inspect. Inform. Protect.',
  slogan: 'Know the Truth Before You Buy.',
  url: SITE_URL,
  logo: LOGO,
  image: LOGO,
  telephone: '+13213003256',
  email: 'carlensauto@gmail.com',
  priceRange: '$$',
  address: { '@type': 'PostalAddress', addressRegion: 'FL', addressCountry: 'US' },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Northeast Florida' },
    { '@type': 'City', name: 'Jacksonville, Florida' },
    { '@type': 'City', name: 'St. Augustine, Florida' },
    { '@type': 'City', name: 'Orange Park, Florida' },
    { '@type': 'City', name: 'Fleming Island, Florida' },
    { '@type': 'City', name: 'Middleburg, Florida' },
    { '@type': 'City', name: 'Fernandina Beach, Florida' },
    { '@type': 'City', name: 'Ponte Vedra Beach, Florida' },
    { '@type': 'City', name: 'Green Cove Springs, Florida' },
    { '@type': 'City', name: 'Palm Coast, Florida' },
    { '@type': 'City', name: 'Amelia Island, Florida' },
    { '@type': 'City', name: 'Gainesville, Florida' },
    { '@type': 'City', name: 'Daytona Beach, Florida' },
  ],
  knowsAbout: [
    'Pre-purchase vehicle inspection',
    'Used car inspection',
    'Mobile vehicle inspection',
    'Facebook Marketplace vehicle inspection',
    'Private seller vehicle inspection',
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    reviewCount: '7',
    bestRating: '5',
    worstRating: '1',
  },
  review: REVIEWS.map((r) => ({
    '@type': 'Review',
    reviewRating: { '@type': 'Rating', ratingValue: String(r.rating), bestRating: '5' },
    author: { '@type': 'Person', name: r.author },
    reviewBody: r.body,
  })),
};

export const WEBSITE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'CarLens Inspections',
  publisher: { '@id': `${SITE_URL}/#organization` },
  potentialAction: {
    '@type': 'SearchAction',
    target: { '@type': 'EntryPoint', urlTemplate: `${SITE_URL}/academy/articles?search={search_term_string}` },
    'query-input': 'required name=search_term_string',
  },
};

export const SITEWIDE_SCHEMAS = [ORGANIZATION_SCHEMA, WEBSITE_SCHEMA];
